import {clsx} from 'clsx'
import type {ComponentProps} from 'react'

import {CardBase} from './card-base'
import styles from './card-base-with-sash.module.css'

type CardBaseWithSashProps = ComponentProps<'div'> & {ref?: React.Ref<HTMLDivElement>}

/**
 * This component adds "sash" styles to the `CardBase` component.
 *
 * A "sash" is basically a thick blue horizontal bar displayed on top or bottom of a card.
 * It is displayed either when another card is being dragged or moved by keyboard and the current card is a possible
 * drop target.
 *
 * The sashes are built using pseudo-elements (:after & :before).
 * They are absolutely positioned relative to the card and their visibility and position
 * are controlled via the card's classes.
 */
export const CardBaseWithSash = ({ref, className, ...props}: CardBaseWithSashProps) => (
  <CardBase className={clsx(styles.CardBaseWithSash, className)} {...props} ref={ref} />
)
CardBaseWithSash.displayName = 'CardBaseWithSash'
